import { array, defaultVal, property } from 'class-converter';
import moment from 'moment';

export class RefEspece {
  @property('id', null, true) id;
  @property('code', null, true) code;
  @property('libelle', null, true) libelle;
  @property('codeCommun', null, true) codeCommun;
  @property('codeEspece', null, true) codeEspece;
}

export class DVSearchAllRespDTO {
  @property('id', null, true) id;
  @property('numeroDV', null, true) numeroDV;
  @property('dateDV', null, true) dateDV;
  @property('etat', null, true) etat;
}

export class ChildrenSrcEspece {
  @defaultVal(null) @property('id', null, true) id;
  @defaultVal(0) @property('quantite', null, true) quantite;
  @defaultVal(0) @property('valeur', null, true) valeur;
  @defaultVal(0) @property('qteSansTolerance', null, true) qteSansTolerance;
  @defaultVal(0) @property('nbCaisses', null, true) nbCaisses;
  @defaultVal(0) @property('poidsVifEstime', null, true) poidsVifEstime;
  @defaultVal(0) @property('poidsADebarqueEstime', null, true) poidsADebarqueEstime;
  @defaultVal(0) @property('poidsADebarqueVerifie', null, true) poidsADebarqueVerifie;
  @defaultVal('') @property('id_refDeclaration', null, true) id_refDeclaration;
  @defaultVal(null) @property('refEspece', RefEspece, true) refEspece;
  @defaultVal('') @property('id_refNavire', null, true) id_refNavire;
  @defaultVal(null) @property('id_refPaysExp', null, true) id_refPaysExp;
  @defaultVal('') @property('tailleCommerciale', null, true) tailleCommerciale;
  @defaultVal(null) @property('refTypeTransformation', null, true) refTypeTransformation;
  @defaultVal(false) @property('selected', null, true) selected;
}

export default class DeclarationVente {
  @property('id', null, true) id;
  @defaultVal('') @property('numeroVisa', null, true) numeroVisa;
  @property('numeroDC', null, true) numeroDC;
  @defaultVal(moment().format('DD/MM/YYYY')) @property('dateDeclaration', null, true) dateDeclaration;
  @defaultVal(null) @property('id_refDeclaration', null, true) id_refDeclaration;
  @defaultVal(null) @property('id_refArmateur', null, true) id_refArmateur;
  @array() @defaultVal([]) @property('childrenSrcEspeceDV', ChildrenSrcEspece, true) childrenSrcEspeceDV = [];
  @array() @defaultVal([]) @property('existingChildrenSrcEspeceDV', ChildrenSrcEspece, true) existingChildrenSrcEspeceDV = [];
}
